import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface IPraemieStatus {
  ZahlungArtId: number;
  Praemie: number;
}

@Injectable()
export class PraemienStatus {

  private praemie$: Subject<IPraemieStatus>;

  constructor() {
    this.praemie$ = new Subject();
  }

  setPraemie(zahlungsArtId: number, praemie: number) {
    this.praemie$.next({
      ZahlungArtId: zahlungsArtId ? zahlungsArtId : 1,
      Praemie: praemie
    });
  }

  resetPraemie() {
    this.praemie$.next(null);
  }

  getPraemie(): Observable<IPraemieStatus> {
    return this.praemie$.asObservable();
  }
}
